import styled from 'styled-components';

export const SubMenuBody = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  color: black;
  padding: 0.8rem 0;
  background: #f7f8fb;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background: #123069;
    z-index: 1;
    pointer-events: none;
  }
`;
